(() => {
  const dayMs = 86400000;
  const dateKey = date => date.toISOString().slice(0, 10);
  const addDays = (date, count) => new Date(date.getTime() + count * dayMs);

  function holidays(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const n = h + l - 7 * m + 114;
    const easter = new Date(Date.UTC(year, Math.floor(n / 31) - 1, n % 31 + 1));
    const kingsDay = new Date(Date.UTC(year, 3, 27));
    const fixed = ['01-01', '05-01', '05-05', '07-21', '08-15', '11-01', '11-11', '12-25', '12-26'];
    return new Set([
      ...fixed.map(value => `${year}-${value}`),
      dateKey(kingsDay.getUTCDay() === 0 ? addDays(kingsDay, -1) : kingsDay),
      ...[-2, 0, 1, 39, 49, 50].map(offset => dateKey(addDays(easter, offset)))
    ]);
  }

  function calculateWindow(now) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(now).filter(part => part.type !== 'literal').map(part => [part.type, part.value]));
    const today = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
    let dispatch = Number(parts.hour) >= 14 ? addDays(today, 1) : today;
    while (dispatch.getUTCDay() === 0 || dispatch.getUTCDay() === 6) dispatch = addDays(dispatch, 1);
    let first = addDays(dispatch, 1);
    while (first.getUTCDay() === 0) first = addDays(first, 1);
    let last = addDays(first, 1);
    while (last.getUTCDay() === 0) last = addDays(last, 1);
    const holidayDates = new Set([...holidays(today.getUTCFullYear()), ...holidays(last.getUTCFullYear())]);
    let holiday = false;
    for (let date = today; date <= last; date = addDays(date, 1)) {
      if (holidayDates.has(dateKey(date))) holiday = true;
    }
    return { dispatch, first, last, holiday };
  }

  function formatWindow(window, locale = 'nl-NL') {
    const sameMonth = window.first.getUTCMonth() === window.last.getUTCMonth() && window.first.getUTCFullYear() === window.last.getUTCFullYear();
    const crossesYear = window.first.getUTCFullYear() !== window.last.getUTCFullYear();
    const format = (date, month) => new Intl.DateTimeFormat(locale, {
      timeZone: 'UTC', weekday: 'short', day: 'numeric',
      ...(month ? { month: 'long' } : {}), ...(crossesYear ? { year: 'numeric' } : {})
    }).format(date);
    return `${format(window.first, !sameMonth)} – ${format(window.last, true)}`;
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { calculateWindow, formatWindow, holidays };
  if (typeof window === 'undefined' || customElements.get('moodtwist-delivery-estimate')) return;

  class MoodtwistDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.variantAvailable = true;
      this.update();
      this.timer = setInterval(() => this.update(), 30000);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.update();
      }, { signal: this.controller.signal });
      document.addEventListener('variant:change', event => {
        if (event.detail?.formId === this.dataset.form) {
          this.variantAvailable = Boolean(event.detail?.variant?.available);
          if (!this.variantAvailable) this.hidden = true;
        }
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.controller?.abort();
    }

    update() {
      if (this.dataset.eligible !== 'true' || !this.variantAvailable) { this.hidden = true; return; }
      const output = this.querySelector('[data-delivery-dates]');
      if (!output) return;
      try {
        const estimate = calculateWindow(new Date());
        output.textContent = estimate.holiday ? this.dataset.holidayText : formatWindow(estimate, this.dataset.locale);
        this.hidden = false;
      } catch {
        output.textContent = this.dataset.fallbackText;
      }
    }
  }
  customElements.define('moodtwist-delivery-estimate', MoodtwistDeliveryEstimate);
})();
